import { tabClasses } from '@mui/material/Tab';
// ----------------------------------------------------------------------
export function tabs(theme) {
    var _a, _b;
    return {
        MuiTabs: {
            styleOverrides: {
                indicator: {
                    backgroundColor: theme.palette.text.primary // Keep indicator color consistent
                },
                scrollButtons: {
                    width: 48,
                    borderRadius: '50%'
                }
            }
        },
        MuiTab: {
            styleOverrides: {
                root: (_a = {
                        padding: 0,
                        opacity: 1,
                        minWidth: 48,
                        minHeight: 48,
                        fontWeight: theme.typography.fontWeightSemiBold,
                        borderRadius: '16px',
                        transition: theme.transitions.create(['color', 'background-color'], {
                            duration: theme.transitions.duration.short
                        }),
                        '&:not(:last-of-type)': (_b = {
                                marginRight: theme.spacing(3)
                            },
                            _b[theme.breakpoints.up('sm')] = {
                                marginRight: theme.spacing(5)
                            },
                            _b),
                        color: '#454F5B'
                    },
                    _a["&.".concat(tabClasses.selected)] = {
                        color: '#161C24' // Active tab color
                    },
                    _a)
            }
        }
    };
}
